export default __webpack_public_path__ + "static/media/SWT1850.34I-40897_-24203_0.bafd9988.jpg";